import React from "react";

interface PlayIconProps {
  className?: string;
  title?: string;
  onClick?: () => void | Promise<void>;
}

export const PlayIcon: React.FC<PlayIconProps> = ({
  className = "",
  title = "",
  onClick,
}) => (
  <svg
    fill="currentColor"
    width="19px"
    height="19px"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width="48" height="48" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <g>
          <path d="M34.6,23.3,18.1,13.2c-.6-.4-1.1-.1-1.1.6V34.2c0,.7.5,1,1.1.6L34.6,24.7A.8.8,0,0,0,34.6,23.3Z" />
          <path d="M24,2A22,22,0,1,0,46,24,21.9,21.9,0,0,0,24,2Zm0,40A18,18,0,1,1,42,24,18.1,18.1,0,0,1,24,42Z" />
        </g>
      </g>
    </g>
  </svg>
);
